import { Model, Store, Casts } from 'store/Base';
import { observable } from 'mobx';
import { Moment } from 'moment';
import { Project } from './Project';
import { Budget } from './Budget';

// [T54191] A sub project IS a milestone: the planning milestone model was
// merged into the sub project. The milestone type/status vocabulary is
// kept for the planning side of the sub project.
export const MILESTONE_TYPE_SPRINT = 'sprint';
export const MILESTONE_TYPE_FEATURE = 'feature';
export const MILESTONE_TYPE_MILESTONE = 'milestone';
export const MILESTONE_TYPE_PHASE = 'phase';
export const MILESTONE_TYPES = [
    MILESTONE_TYPE_SPRINT,
    MILESTONE_TYPE_FEATURE,
    MILESTONE_TYPE_MILESTONE,
    MILESTONE_TYPE_PHASE,
];

export const MILESTONE_STATUS_PLANNING = 'planning';
export const MILESTONE_STATUS_ACTIVE = 'active';
export const MILESTONE_STATUS_COMPLETED = 'completed';
export const MILESTONE_STATUS_ON_HOLD = 'on_hold';
export const MILESTONE_STATUSES = [
    MILESTONE_STATUS_PLANNING,
    MILESTONE_STATUS_ACTIVE,
    MILESTONE_STATUS_COMPLETED,
    MILESTONE_STATUS_ON_HOLD,
];

export class Subproject extends Model {
    static backendResourceName = 'subproject';
    static omitFields = ['fullName', 'spentHours', 'plannedHours', 'displayName']

    @observable id = null;
    @observable name = '';
    @observable description: string | null = null;
    @observable project = this.relation(Project);
    @observable budget = this.relation(Budget);

    // [T53675] Optional own hour budget, separate from the linked budget
    // (e.g. "MVP" capped at 600h inside a 400k€ project budget). Hours
    // logged on the sub project count towards both this cap and the
    // linked budget's hours/money.
    @observable budgetHours: null | number = null;

    // [T54191] Planning / milestone semantics (unified from the old
    // planning milestone model).
    @observable type = MILESTONE_TYPE_MILESTONE;
    @observable status = MILESTONE_STATUS_PLANNING;
    @observable startDate: Moment | null = null;
    @observable deadline: Moment | null = null;
    @observable order = 0;
    @observable phabricatorProjectPhid: string | null = null;

    @observable createdAt: null | Moment = null;

    @observable spentHours = 0;

    // [T54191] Sum of the estimated hours of this sub project's (milestone's)
    // planning tickets — the work planned/allocated on it. Computed
    // backend-side (annotation), read-only.
    @observable plannedHours = 0;

    casts() {
        return {
            createdAt: Casts.nullableDatetime,
            startDate: Casts.date,
            deadline: Casts.date,
        };
    }

    // Company - Project - Sub project (annotation on backend)
    @observable fullName = '';

    // [T53675 feedback] Company - Sub project: the compact label the time
    // registration picker / quick bar shows (annotation on backend).
    @observable displayName = '';
}

export class SubprojectStore extends Store {
    Model = Subproject;
    static backendResourceName = 'subproject';
}
